import { Box, Grid } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ScrollableTabs, TabTextVariant, WsTitleBanner } from 'wisestep-base';

import { AppLayoutTheme } from '../../../candidates/utils/CandidateHelper';

import BroadCastTable from './broadCastTable/BroadCastTable';
import ImportHistoryCard from './importHistoryCard';

const HistoryListing = () => {
  const navigate = useNavigate();
  const [tabPanelPage, setTabPanelPage] = useState(0);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <AppLayoutTheme>
          <WsTitleBanner title="History" goBack={() => navigate('/vendors')} />
        </AppLayoutTheme>
      </Grid>

      <Grid item xs={12}>
        <Box>
          <ScrollableTabs
            variant={TabTextVariant.SUB_TITLE}
            scrollList={[{ tabName: 'Broadcast History' }, { tabName: 'Import History' }]}
            getTabIndex={(index: number) => setTabPanelPage(index)}
          />

          {tabPanelPage === 0 && <BroadCastTable />}

          {tabPanelPage === 1 && <ImportHistoryCard />}
        </Box>
      </Grid>
    </Grid>
  );
};
export default HistoryListing;
